"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestIdleCallback = void 0;

var requestIdleCallback = function requestIdleCallback(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (window.hasOwnProperty('requestIdleCallback')) {
    var callbackId = window.requestIdleCallback(callback, {
      timeout: timeout
    });
    return function () {
      return window.cancelIdleCallback(callbackId);
    };
  }

  var timeoutId = window.setTimeout(callback, timeout);
  return function () {
    return window.clearTimeout(timeoutId);
  };
};

exports.requestIdleCallback = requestIdleCallback;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/requestIdleCallback.js
// module id = 790
// module chunks = 209 210 211 212